import { useTranslation } from 'react-i18next';
import { MAIN_SITE_URL } from '@/mocks/categories';

const HERO_IMAGE =
  'https://readdy.ai/api/search-image?query=A%20vibrant%20stylized%203D%20illustration%20of%20assorted%20fashion%20shopping%20items%20a%20sneaker%20a%20hoodie%20a%20cap%20a%20handbag%20and%20a%20gift%20box%20floating%20in%20a%20soft%20mint%20and%20cream%20scene%20with%20gentle%20pastel%20geometric%20shapes%20abstract%20premium%20ecommerce%20hero%20artwork%20with%20clean%20modern%20composition&width=1400&height=1050&seq=hero-flatlay-v2&orientation=landscape';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-2 lg:gap-16">
        <div className="order-2 lg:order-1">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700 whitespace-nowrap">
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-sparkling-2-line text-xs"></i>
            </span>
            {t('hero_badge')}
          </span>

          <h1 className="mt-5 text-3xl font-bold leading-tight text-foreground-950 md:text-4xl lg:text-[2.75rem]">
            {t('hero_title')}
          </h1>

          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            {t('hero_subtitle')}
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-base font-semibold text-white transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
            >
              {t('hero_cta_primary')}
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </span>
            </a>
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-accent-500 px-6 py-3 text-base font-semibold text-white transition-colors hover:bg-accent-600 cursor-pointer whitespace-nowrap"
            >
              {t('hero_cta_secondary')}
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-shopping-bag-3-line text-sm"></i>
              </span>
            </a>
          </div>

          <p className="mt-5 flex items-center gap-2 text-sm text-foreground-500">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-information-line text-sm"></i>
            </span>
            {t('hero_hint')}
          </p>
        </div>

        <div className="order-1 lg:order-2">
          <div className="relative h-[300px] w-full overflow-hidden rounded-2xl md:h-[460px]">
            <img
              src={HERO_IMAGE}
              alt="USFans Spreadsheet product collection flat lay"
              title="USFans Spreadsheet products and categories"
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent"></div>
          </div>
        </div>
      </div>
    </section>
  );
}